import { apiRequest } from "./client";

export async function postTemplate(template) {
  const response = await apiRequest("/api/v1/templates", {
    method: "POST",
    body: JSON.stringify(template),
  });
  if (!response.ok) {
    const err = await response.json();
    throw err;
  }
  return response.json();
}

export async function fetchTemplate(templatePublicId) {
  const response = await apiRequest(`/api/v1/templates/${templatePublicId}`);
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw err;
  }
  return response.json();
}

export async function updateTemplate(template) {
  const response = await apiRequest(`/api/v1/templates/${template.public_id}`, {
    method: "PATCH",
    body: JSON.stringify(template),
  });
  if (!response.ok) {
    const err = await response.json();
    throw err;
  }
  return response.json();
}

export async function uploadTemplateImage(file) {
  const formData = new FormData();
  formData.append("file", file);

  const response = await apiRequest("/api/v1/template-images", {
    method: "POST",
    body: formData,
  });

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.detail || "画像のアップロードに失敗しました");
  }

  return response.json();
}

function getTemplateImageKey(imagePath) {
  return imagePath.startsWith("template-images/")
    ? imagePath.substring("template-images/".length)
    : imagePath;
}

export async function fetchTemplateImageSignedUrl(imagePath) {
  const imageKey = getTemplateImageKey(imagePath);
  const response = await apiRequest(
    `/api/v1/template-images/signed-url?path=${encodeURIComponent(imageKey)}`
  );

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.detail || "画像URLの取得に失敗しました");
  }

  const data = await response.json();
  if (!data.url) {
    throw new Error("画像URLの取得に失敗しました");
  }

  return data.url;
}

export async function openTemplateImage(imagePath) {
  const newWindow = window.open("", "_blank");

  if (!newWindow) {
    throw new Error("新しいタブを開けませんでした。ポップアップ設定を確認してください。");
  }

  newWindow.opener = null;
  newWindow.document.title = "Loading...";
  newWindow.document.body.innerHTML =
    "<p style=\"font-family: sans-serif; padding: 16px;\">Loading...</p>";

  try {
    const signedUrl = await fetchTemplateImageSignedUrl(imagePath);
    newWindow.location.replace(signedUrl);
  } catch (error) {
    newWindow.close();
    throw error;
  }
}

export async function deleteTemplateImage(imagePublicId) {
  const response = await apiRequest(`/api/v1/template-images/${imagePublicId}`, {
    method: "DELETE",
  });

  if (!response.ok && response.status !== 404) {
    let errorDetail = "画像の削除に失敗しました。";
    try {
      const errorData = await response.json();
      errorDetail = errorData.detail || errorDetail;
    } catch (e) {
      console.error("Failed to parse error response:", e);
    }
    throw new Error(errorDetail);
  }
  return;
}
